import { AUTH_URL, DOC2API_URL } from 'pages/APIs';
export const api = {
  register_supplier: AUTH_URL + '/supplier/register',
  get_supplier_details: AUTH_URL + '/supplier/supplier_details',
  get_organisation_suppliers:
    DOC2API_URL + '/org_details/get_organisation_suppliers',
  get_organisation_supplier_detail:
    DOC2API_URL + '/org_details/get_organisation_supplier_detail',
  send_magic_link: AUTH_URL + '/supplier/send_magic_link',
  get_magic_link_data: AUTH_URL + '/supplier/get_magic_link_data',
  update_supplier_details: DOC2API_URL + '/supplier/update_supplier_details',
  upload_document: DOC2API_URL + '/supplier/upload_document',
  get_supplier_detail_file: DOC2API_URL + '/supplier/get_supplier_detail_file',
  delete_document: DOC2API_URL + '/supplier/delete_document',
  send_for_approval: DOC2API_URL + '/supplier/send_for_approval',
  supplier_reject: DOC2API_URL + '/supplier/reject',
  supplier_approve: DOC2API_URL + '/supplier/approve',
  get_supplier_online_detail:
    DOC2API_URL + '/org_details/check_supplier_chat_online',
  get_sync_data_m3: DOC2API_URL + '/supplier/sync_supplier_m3',
};
